import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import permission from './modules/permission'
import enhance from './modules/enhance'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    permission,
    enhance,
  },
  state: {
    arry2:[0,1],
    card_list:[
      {}
    ],
    show:1,
    params:{
      lqjbr:"",
      lqzbdw:"",
      xysl:"",
      ffr:"",
      ffrq:"",
      ytzm:"",
      lqdwyj:"",
      fgdwyj:"",
      spyj:"",
      bz:""
    },
    list:[],
    list_id:0,
    wzid:"",
    navIndex:0,
    searchValue: '',
    searchNum:0,
  },
  mutations: {
    change_cardList(state,payload){
      state.card_list[payload.id] = payload.item
      console.log("触发card_list",state.card_list);
    }
  },
  actions: {

  },
  getters
})
